import React from "react";

function IconButton({ 
  onClick, 
  children, 
  className = "", 
  size = "md",
  variant = "ghost"
}) {
  const sizeClasses = {
    sm: "w-8 h-8",
    md: "w-10 h-10", 
    lg: "w-12 h-12"
  };

  const variantClasses = {
    ghost: "text-gray-500 hover:text-gray-700 hover:bg-gray-100",
    outline: "text-gray-600 border border-gray-200 hover:bg-gray-50 hover:border-gray-300",
    solid: "text-white bg-gray-600 hover:bg-gray-700"
  };

  return (
    <button
      onClick={onClick}
      className={`inline-flex items-center justify-center rounded-lg transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-orange-500 cursor-pointer ${sizeClasses[size]} ${variantClasses[variant]} ${className}`}
    >
      {children}
    </button>
  );
}

export default IconButton;
